import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { ListItemButton, ListItemText, useTheme } from '@mui/material';

type Props = {
  to: string;
  name: string;
  exact?: boolean;
};

const NavItem: React.FC<Props> = ({ to, name }: Props) => {
  const theme = useTheme();

  return (
    <ListItemButton
      component={NavLink}
      to={to}
      sx={{
        width: 'auto',
        overflow: 'auto',
        flexGrow: 1,
        color: theme.palette.primary.main,
        textAlign: 'center',
        '&.active': {
          borderBottom: `3px solid ${theme.palette.primary.main}`,
        },
        [theme.breakpoints.down('md')]: {
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
        },
        [theme.breakpoints.down('sm')]: {
          paddingLeft: theme.spacing(0.25),
          paddingRight: theme.spacing(0.25),
        },
      }}
    >
      <ListItemText
        primary={name}
        primaryTypographyProps={{
          noWrap: true,
          sx: {
            [theme.breakpoints.down('md')]: {
              fontSize: theme.typography.body2.fontSize,
            },
            [theme.breakpoints.down('sm')]: {
              fontSize: '0.75rem',
            },
          },
        }}
      />
    </ListItemButton>
  );
};

export default NavItem;
